export enum PersonalIdentifierType {
  BIRTH_CERTIFICATE = 'BIRTH_CERTIFICATE',
  DRIVER_LICENSE = 'DRIVER_LICENSE',
  EDUCATION = 'EDUCATION',
  FREE_BLOCK = 'FREE_BLOCK',
  INTERNATIONAL_DRIVER_LICENSE = 'INTERNATIONAL_DRIVER_LICENSE',
  MEDICAL_ID = 'MEDICAL_ID',
  MILITARY_ID = 'MILITARY_ID',
  NATIONAL_ID = 'NATIONAL_ID',
  PASSPORT = 'PASSPORT',
  RESIDENCE_PERMIT = 'RESIDENCE_PERMIT',
  SOCIAL_SECURITY = 'SOCIAL_SECURITY',
  CITIZENSHIP_CERTIFICATE = 'CITIZENSHIP_CERTIFICATE',
  SUBSTANCE = 'SUBSTANCE',
  TAX_ID = 'TAX_ID',
}
